import { withStylePrefix } from '../common/withStylePrefix';
import { PopoverV2Component, popoverV2Template } from './PopoverV2';
import styles from './PopoverV2.styles.scss';
export const chameleonPopoverV2 = PopoverV2Component.compose({
    baseName: 'popover-v2',
    template: popoverV2Template,
    styles: withStylePrefix(styles),
});
